import { useState } from 'react'
import useSWR from 'swr'
import { coreApiClient } from '../api'

const REFRESH_INTERVAL = 5000

export const useOrgSubscription = ({ orgId }) => {
  const [isRequested, setIsRequested] = useState(false)
  /**
   * Get org current subscription
   */
  let {
    data,
    error: orgSubscriptionError,
    mutate: refreshSubscription,
  } = useSWR(orgId && `/billing/orgs/${orgId}?expand=[pricing]`, coreApiClient, {
    shouldRetryOnError: false,
    onSuccess: (data) => {
      setIsRequested(data?.status === 'requested')
    },
    refreshInterval: isRequested ? REFRESH_INTERVAL : 0,
  })
  const orgSubscription = data
  return {
    orgSubscription,
    orgSubscriptionError,
    refreshSubscription,
  }
}
